// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-carousel":"Breadcrumbs_breadcrumbs-carousel__Aq_Uq","breadcrumbs-carousel--singleColumn":"Breadcrumbs_breadcrumbs-carousel--singleColumn__njQNA"};